import React from 'react';
import { Link } from 'react-router-dom';
import './index.less';
import { IUser } from '../../reducers/auth-reducers';

interface INotAvailableProps {
	user: IUser;
	location: URL;
}

export class NotAvailable extends React.Component<INotAvailableProps> {
	render() {
		const {
			location: { pathname, search },
			user: { id },
		} = this.props;
		const isSignedIn = id !== '-1';
		const returnUrl = pathname + search;
		return (
			<div className="not-available">
				<div className="container">
					<h3>This content is not available.</h3>
					{isSignedIn ? (
						<Link to="/">
							<button>Back to Homepage</button>
						</Link>
					) : (
						[
							<div key="0">Sign in and try again.</div>,
							<Link key="1" to={`/signin?returnUrl=${encodeURI(returnUrl)}`}>
								<button>Sign In</button>
							</Link>,
						]
					)}
				</div>
			</div>
		);
	}
}
